import { render, staticRenderFns } from "./RmCatalogueErrorPopUp.vue?vue&type=template&id=981a68a6&scoped=true&"
import script from "./RmCatalogueErrorPopUp.vue?vue&type=script&lang=js&"
export * from "./RmCatalogueErrorPopUp.vue?vue&type=script&lang=js&"
import style0 from "./RmCatalogueErrorPopUp.vue?vue&type=style&index=0&id=981a68a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981a68a6",
  null
  
)

export default component.exports